import React from 'react';
import Head from 'next/head';
import BaseHead, { blogPageMeta } from 'app/components/blog/BaseHead';
import he from 'he';

const { name, locale, url } = blogPageMeta;

const PageHead = props => {
  // Selectors
  const { author } = props;

  const authorName = he.encode(author.name);
  const authorDesc = he.encode(author.description);
  const title = `${author.name}, Author at ${name}`;
  const encodedTitle = he.encode(title);
  const authorUrl = `${url}author/${author.slug}/`;
  const ldJson = {
    '@graph': [
      {
        '@type': 'ProfilePage',
        '@id': `${authorUrl}#webpage`,
        url: authorUrl,
        inLanguage: locale,
        name: encodedTitle,
        isPartOf: {
          '@id': `${url}#website`,
        },
      },
      {
        '@type': 'Person',
        '@id': `${authorUrl}#author`,
        name: authorName,
        image: {
          '@type': 'ImageObject',
          '@id': `${name}#personlogo`,
          url: author.imageUrl,
          caption: authorName,
        },
        description: authorDesc,
        sameAs: [],
        mainEntityOfPage: {
          '@id': `${authorUrl}#webpage`,
        },
      },
    ],
  };
  return (
    <Head>
      <BaseHead />
      <title>{title}</title>
      <meta name="robots" content="noindex" />
      <meta property="og:type" content="object" />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={authorUrl} />
      <meta property="twitter:title" content={title} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: BaseHead.buildLdJson(ldJson) }}
      />
    </Head>
  );
};

export default PageHead;
